import SettingsRepository from './settings.repository'

export default {
  settings: SettingsRepository,
}
